import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {modelFetched} from 'models/ManagedModelsReduxActions';
import {Thunk} from 'redux-stores/Store';

import {AssayValidationComment, ValidatableInput, WritableAssayValidationStatus} from './ValidationConstants';
import * as ValidationDAO from './ValidationDAO';

export function bulkSetAssayValidation(
  validatableInputs: Array<ValidatableInput>,
  status: WritableAssayValidationStatus,
  comment: AssayValidationComment
): Thunk<Promise<void>> {
  return async (dispatch) => {
    const {assayResultValidationsByResultId, assayRunValidationsByRunId} =
      await ValidationDAO.bulkSetAssayValidation(validatableInputs, status, comment);
    dispatch(modelFetched(ManagedModelType.ASSAY_RESULT_VALIDATION, assayResultValidationsByResultId));
    dispatch(modelFetched(ManagedModelType.ASSAY_RUN_VALIDATION, assayRunValidationsByRunId));
  };
}
